<div class="title-container">
    <ui-button
            *ngIf="hasReturn"
            type="button"
            tooltip="Voltar"
            variant="ghost"
            color="secondary"
            class="return-button"
            (click)="onReturnClick()">
        <i class="la la-arrow-left"></i>
    </ui-button>

    <span class="icon-container">
        <i class="{{icon}}"></i>
    </span>
    <div class="title">
        <h1>
            <ng-content></ng-content>
        </h1>
        <h2 *ngIf="subtitle"
            #h2
            [title]="h2.textContent"
            [innerHTML]="subtitle"
        ></h2>
    </div>
</div>

<ui-button
        *ngIf="hasRefresh"
        type="button"
        (click)="onRefreshClick()"
        class="refresh-button"
        variant="ghost"
        color="secondary"
        tooltip="Atualizar"
>
    <i class="flaticon2-refresh"></i>
</ui-button>
